import React from 'react';
import { Trans } from 'lingui-react';

import rectangleStep from '../../../../../../assets/images/RectangleStep.svg';
import rectangleStepActive from '../../../../../../assets/images/rectagleActive.svg';
import checkTag from '../../../../../../assets/images/checkTag.svg';
import uncheckTag from '../../../../../../assets/images/uncheckTag.svg';

export const HeaderTag = props => {
  return (
    <div onClick={props.onClick} className="step-container">
      <p className={props.active ? 'step-header' : 'step-header-disable'}>
        <img
          className="check-header-tag"
          alt=""
          src={props.active ? checkTag : uncheckTag}
        />
        <Trans id={props.tagContent} />
      </p>
      <img
        className="step-arrow"
        key="key-2"
        src={props.active ? rectangleStep : rectangleStepActive}
        alt=""
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Header/components/HeaderQuestion/components/HeaderTag/HeaderTag.js